// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-diagnostic-page {
  min-height: 100vh;
  background: #111111;
  color: #ffffff;
  padding: 140px 6vw 90px;
}

.ai-diagnostic-title {
  font-size: clamp(36px, 4.8vw, 72px);
  font-weight: 500;
  margin: 0 0 56px;
  letter-spacing: -0.02em;
}

.ai-diagnostic-grid {
  display: grid;
  grid-template-columns: minmax(420px, 1.3fr) minmax(340px, 0.9fr);
  gap: 40px;
  align-items: stretch;
}

.ai-card {
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.08),
    rgba(255, 255, 255, 0.02)
  );
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 18px;
  padding: 22px;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.ai-card-tall {
  min-height: 540px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  height: 100%;
}

.ai-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #759200;
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.02em;
  width: fit-content;
}

.ai-role-input {
  width: 100%;
  margin-bottom: 14px;
  background: rgba(18, 18, 18, 0.35);
  border: 1px solid rgba(204, 255, 0, 0.2);
  color: #ffffff;
  padding: 12px 14px;
  border-radius: 12px;
  font-family: "Satoshi", sans-serif;
  font-size: 16px;
  line-height: 1.4;
}

.ai-role-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.ai-options {
  display: grid;
  gap: 10px;
}

.ai-option {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  color: #f5f5f5;
}

.ai-option input {
  accent-color: #ccff00;
  width: 18px;
  height: 18px;
}

.ai-textarea {
  width: 100%;
  min-height: 170px;
  background: rgba(18, 18, 18, 0.35);
  border: 1px solid rgba(204, 255, 0, 0.2);
  color: #ffffff;
  padding: 14px;
  border-radius: 12px;
  resize: none;
  font-family: "Satoshi", sans-serif;
  font-size: 16px;
  line-height: 1.5;
}

.ai-textarea::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.ai-char-counter {
  font-size: 13px;
  opacity: 0.55;
  text-align: right;
}

.ai-error {
  margin: 0 0 8px;
  font-size: 14px;
  color: #ff6b6b;
}

.ai-primary-btn {
  width: 100%;
  background: rgba(18, 18, 18, 0.35);
  color: #ccff00;
  font-weight: 600;
  padding: 12px 18px;
  border-radius: 10px;
  border: 1px solid rgba(204, 255, 0, 0.5);
  cursor: pointer;
  font-size: 15px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ai-primary-btn:hover:enabled {
  background: rgba(40, 40, 45, 0.85);
  border-color: rgba(204, 255, 0, 0.7);
  color: #ccff00;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

.ai-primary-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.ai-right-stack {
  display: grid;
  gap: 24px;
}

.ai-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 12px;
  font-size: 16px;
  line-height: 1.5;
}

.ai-checklist {
  display: grid;
  gap: 12px;
  margin: 0 0 20px;
}

.ai-check-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  line-height: 1.4;
}

.ai-check-item input {
  accent-color: #ccff00;
  width: 18px;
  height: 18px;
}

.ai-muted {
  opacity: 0.5;
  font-size: 16px;
}

.ai-list-icon {
  display: inline-flex;
  width: 24px;
  justify-content: center;
  margin-right: 6px;
}

.ai-solution-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
}

.ai-solution-link:hover {
  text-decoration: underline;
  color: #ccff00;
}

@media (max-width: 1024px) {
  .ai-diagnostic-grid {
    grid-template-columns: 1fr;
  }

  .ai-card-tall {
    min-height: auto;
  }
}

@media (max-width: 768px) {
  .ai-diagnostic-page {
    padding: 120px 6vw 70px;
  }

  .ai-diagnostic-title {
    margin-bottom: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ai-diagnostic/ai-diagnostic.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE;;;;GAIC;EACD,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;EACnC;;2CAEyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".ai-diagnostic-page {\n  min-height: 100vh;\n  background: #111111;\n  color: #ffffff;\n  padding: 140px 6vw 90px;\n}\n\n.ai-diagnostic-title {\n  font-size: clamp(36px, 4.8vw, 72px);\n  font-weight: 500;\n  margin: 0 0 56px;\n  letter-spacing: -0.02em;\n}\n\n.ai-diagnostic-grid {\n  display: grid;\n  grid-template-columns: minmax(420px, 1.3fr) minmax(340px, 0.9fr);\n  gap: 40px;\n  align-items: stretch;\n}\n\n.ai-card {\n  background: linear-gradient(\n    145deg,\n    rgba(255, 255, 255, 0.08),\n    rgba(255, 255, 255, 0.02)\n  );\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 18px;\n  padding: 22px;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow:\n    0 20px 50px rgba(0, 0, 0, 0.35),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n}\n\n.ai-card-tall {\n  min-height: 540px;\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  height: 100%;\n}\n\n.ai-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #759200;\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n  width: fit-content;\n}\n\n.ai-role-input {\n  width: 100%;\n  margin-bottom: 14px;\n  background: rgba(18, 18, 18, 0.35);\n  border: 1px solid rgba(204, 255, 0, 0.2);\n  color: #ffffff;\n  padding: 12px 14px;\n  border-radius: 12px;\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.ai-role-input::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.ai-options {\n  display: grid;\n  gap: 10px;\n}\n\n.ai-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  color: #f5f5f5;\n}\n\n.ai-option input {\n  accent-color: #ccff00;\n  width: 18px;\n  height: 18px;\n}\n\n.ai-textarea {\n  width: 100%;\n  min-height: 170px;\n  background: rgba(18, 18, 18, 0.35);\n  border: 1px solid rgba(204, 255, 0, 0.2);\n  color: #ffffff;\n  padding: 14px;\n  border-radius: 12px;\n  resize: none;\n  font-family: \"Satoshi\", sans-serif;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.ai-textarea::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.ai-char-counter {\n  font-size: 13px;\n  opacity: 0.55;\n  text-align: right;\n}\n\n.ai-error {\n  margin: 0 0 8px;\n  font-size: 14px;\n  color: #ff6b6b;\n}\n\n.ai-primary-btn {\n  width: 100%;\n  background: rgba(18, 18, 18, 0.35);\n  color: #ccff00;\n  font-weight: 600;\n  padding: 12px 18px;\n  border-radius: 10px;\n  border: 1px solid rgba(204, 255, 0, 0.5);\n  cursor: pointer;\n  font-size: 15px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ai-primary-btn:hover:enabled {\n  background: rgba(40, 40, 45, 0.85);\n  border-color: rgba(204, 255, 0, 0.7);\n  color: #ccff00;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n}\n\n.ai-primary-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.ai-right-stack {\n  display: grid;\n  gap: 24px;\n}\n\n.ai-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 12px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.ai-checklist {\n  display: grid;\n  gap: 12px;\n  margin: 0 0 20px;\n}\n\n.ai-check-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.ai-check-item input {\n  accent-color: #ccff00;\n  width: 18px;\n  height: 18px;\n}\n\n.ai-muted {\n  opacity: 0.5;\n  font-size: 16px;\n}\n\n.ai-list-icon {\n  display: inline-flex;\n  width: 24px;\n  justify-content: center;\n  margin-right: 6px;\n}\n\n.ai-solution-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: none;\n}\n\n.ai-solution-link:hover {\n  text-decoration: underline;\n  color: #ccff00;\n}\n\n@media (max-width: 1024px) {\n  .ai-diagnostic-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .ai-card-tall {\n    min-height: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .ai-diagnostic-page {\n    padding: 120px 6vw 70px;\n  }\n\n  .ai-diagnostic-title {\n    margin-bottom: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
